import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LandlordReviewPage from '../pages/LandlordReviewPage';
import TermsPage from '../pages/TermsPage';
import ApplicationsTabPage from '../pages/ApplicationsTabPage';
import MissingPermissionsPage from '../pages/MissingPermissionsPage';
import FailedRequestPage from '../pages/FailedRequestPage';
import TenantScreeningServicesPage from '../pages/TenantScreeningServicesPage';
import IdVerificationModal from '../pages/IdVerificationModal';
import { ShareRequestPage } from '../pages/ShareRequestPage';

import {
  BASE,
  FAILED_REQUEST,
  ID_VERIFICATION,
  LANDLORD_REVIEW,
  MISSING_PERMISSIONS,
  SHARE,
  TERMS,
  ZILLOW_TENANT_SCREENING_SERVICES,
} from '../constants/paths';

export default function Routes() {
  return (
    <Switch>
      <Route component={TermsPage} path={TERMS} />
      <Route component={IdVerificationModal} path={ID_VERIFICATION} />
      <Route component={MissingPermissionsPage} path={MISSING_PERMISSIONS} />
      <Route component={FailedRequestPage} path={FAILED_REQUEST} />
      <Route component={TenantScreeningServicesPage} path={ZILLOW_TENANT_SCREENING_SERVICES} />
      <Route component={ShareRequestPage} path={SHARE} />
      <Route component={LandlordReviewPage} path={LANDLORD_REVIEW} />
      <Route component={ApplicationsTabPage} path={BASE} />
    </Switch>
  );
}
